import React from 'react'

function PrintButton(props) {
  const { app, hash } = props
  const printUrl = './api/print?app=' + app + '&hash=' + hash
  return (
    <center style={{ marginTop: 10, marginBottom: 25 }}>
      <a className="btn btn-danger" href={printUrl}>
        Scarica come PDF
      </a>
    </center>
  )
}

export default PrintButton



// WEBPACK FOOTER //
// ./src/PrintButton.js